import { lazy, Suspense } from 'react';

import { Loading } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';

const LoadableComponent = lazy(() =>
  retry(() => import('./SuggestedProducts'))
);

const SuggestedProductsLoader = () => (
  <Suspense fallback={<Loading />}>
    <LoadableComponent />
  </Suspense>
);

export default SuggestedProductsLoader;
